// time for refresh token
export var SECONDS_BEFORE_EXPIRATION = 600; // Internal SDK events, subscribed by SyncManager and PushManager

export var PUSH_CONNECT = 'PUSH_CONNECT';
export var PUSH_DISABLED = 'PUSH_DISABLED';
export var PUSH_DISCONNECT = 'PUSH_DISCONNECT';
export var SSE_ERROR = 'SSE_ERROR'; // Update-type push notifications, handled by NotificationProcessor

export var MY_SEGMENTS_UPDATE = 'MY_SEGMENTS_UPDATE';
export var SEGMENT_UPDATE = 'SEGMENT_UPDATE';
export var SPLIT_KILL = 'SPLIT_KILL';
export var SPLIT_UPDATE = 'SPLIT_UPDATE'; // Control-type push notifications, handled by NotificationKeeper

export var CONTROL = 'CONTROL';
export var OCCUPANCY = 'OCCUPANCY';
export var ControlTypes = {
  STREAMING_DISABLED: 'STREAMING_DISABLED',
  STREAMING_PAUSED: 'STREAMING_PAUSED',
  STREAMING_RESUMED: 'STREAMING_RESUMED'
};